import { Table } from "react-bootstrap";
import { Product } from "./types";
import { JSONPath } from "jsonpath-plus";
import { Check, X } from "react-bootstrap-icons";
import fr from './translations/fr.json'
import en from './translations/en.json'

function t(key: string, currentLanguage = "fr") {
    return JSONPath({ path: key, json: currentLanguage === 'fr' ? fr : currentLanguage === 'en' ? en : fr });
}

export interface UsageQuotasProps {
    currentLanguage: string
    products: Product[]
}

export function UsageQuotas({
    currentLanguage = 'fr',
    products = []
}: UsageQuotasProps) {

    return (
        <Table striped bordered hover size="lg">
            <thead>
                <tr>
                    <th>{t("modalQuotas.table.columns.action", currentLanguage)}</th>
                    <th>{t("modalQuotas.table.columns.currentUsage", currentLanguage)}</th>
                    <th>{t("modalQuotas.table.columns.maxUsage", currentLanguage)}</th>
                    <th>{t("modalQuotas.table.columns.maxUsageTimeframe", currentLanguage)}</th>
                    <th>{t("modalQuotas.table.columns.isAvailable", currentLanguage)}</th>
                </tr>
            </thead>
            <tbody>
                {products.map((product: Product) =>
                    <tr key={`product-${product.id}`}>
                        <td>{t(product.displayLabel || "", currentLanguage)}</td>
                        <td>{product.currentUsage}</td>
                        <td>{product.maxUsage}</td>
                        <td>{product.maxUsagePeriodInDay}</td>
                        <td>{product.isAvailable ?
                            <Check color="green" size={20} /> :
                            <X color="red" size={20} />}
                        </td>
                    </tr>
                )}
            </tbody>
        </Table>
    );
}